<div
  class="rs-has-overlap"
  data-tms-event="card-click-impression"
  attr.data-tms-card-zone="{{ getTaggingZone() }}"
  data-tms-card-name="new offer"
>
  <div class="panel rs-bg-tr-b1">
    <mprd-patch
      [patchShape]="'bottom-left'"
      [patchType]="'info'"
      [customClass]="'rs-is-overlapping'"
    >
      {{ 'products.card.jointOffer.newOffer' | translate }}
    </mprd-patch>
    <h3 class="rs-txt-c1 rs-txt-s4 rs-padding-bottom1">
      {{ 'products.card.jointOffer.title' | translate }}
    </h3>
    <p>{{ 'products.card.jointOffer.description' | translate }}</p>
    <div class="rs-entrypoint-container">
      <a
        href="javascript:void(0)"
        class="rs-entrypoint"
        data-tms-button-name="renew now"
        data-cy="renew-now-button"
        (click)="navigateToRenewJointOffer(); $event.stopPropagation()"
      >
        <i class="icon-Caddy icon-lh rs-entrypoint-icon" aria-hidden="true"></i>
        <span class="rs-entrypoint-title">
          {{ 'products.card.jointOffer.button.renew' | translate }}
        </span>
        <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
      </a>

      <button
        class="rs-entrypoint"
        data-reveal-id="joRenewalConditions"
        aria-haspopup="true"
        data-tms-button-name="info and conditions"
        data-cy="info-condition-button"
        (click)="navigateToInformationJointOffer(); $event.stopPropagation()"
        type="button"
      >
        <i class="icon-Information-box icon-lh rs-entrypoint-icon" aria-hidden="true"></i>
        <span class="rs-entrypoint-title">{{
          'products.card.jointOffer.button.information' | translate
        }}</span>
        <span class="rs-entrypoint-arrow" aria-hidden="true"></span>
      </button>
    </div>
  </div>
</div>

<div
  aria-labelledby="ac-joRenewalConditions-label"
  class="reveal-modal"
  data-reveal=""
  id="joRenewalConditions"
  role="dialog"
>
  <div class="rs-modal-close">
    <button class="rs-link-action rs-link-action-close close-reveal-modal">
      <span class="rs-action-link-icon" [title]="'common.overlayer.close.caption' | translate">
        <span class="show-for-sr">{{ 'common.overlayer.close.caption' | translate }}</span>
      </span>
    </button>
  </div>
  <div class="rs-modal-heading">
    <h2 class="rs-modal-heading-title" id="ac-joRenewalConditions-label">
      {{ 'products.card.jointOffer.informationPopup.title' | translate }}
    </h2>
  </div>
  <div
    class="rs-modal-content"
    [innerHTML]="'products.card.jointOffer.informationPopup.content' | translate"
  ></div>
</div>
